import clubs from './clubs'
import members from './members'
import finance from './finance'
import security from './security'
import province from './province'
import club from './club'

export const menu = {
  namespaced: true,
  state: {
    items: [
      clubs,
      members,
      finance,
      security,
      province,
      club
    ],
    expandeditems: []
  },
  getters: {
    menuItems: state => state.items,
    isExpanded: state => (menuItem) => {
      return state.expandeditems.findIndex((i) => {
        return i === menuItem
      }) >= 0
    }
  },
  mutations: {
    ClearMenu (state) {
      state.items = state.items.filter((item) => { return item.createroutes })
      state.expandeditems = []
    },
    ToggleExpand (state, menuItem) {
      let index = state.expandeditems.findIndex((i) => {
        return i === menuItem
      })
      if (index >= 0) {
        state.expandeditems.splice(index, 1)
      } else {
        state.expandeditems.push(menuItem)
      }
    },
    MutAddToMenu (state, menuItem) {
      state.items.push(menuItem)
    }
  },
  actions: {
    expandMenu: ({commit}, menuItem) => {
      if (menuItem) {
        commit('ToggleExpand', menuItem)
      }
    },
    AddItemToMenu (context, item) {
      context.commit('MutAddToMenu', item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menu/index.js